import React from "react";
import { useNavigate } from "react-router-dom";
import WriteBox from "../../QuestionPage/WordBox";
import QuestionBox from "../../QuestionPage/questionbox";
import { useState, useEffect } from "react";
import Timer from "../Timer";

// Fetching Data from the API]

// End

// Page Html
export default function WriteEssayMockPage({ question , onInputChange,questionNumber}) {
  const [text, setText] = useState("");
  const navigate = useNavigate();

  const handleTextChange = (newText) => {
    setText(newText);
    onInputChange(newText);

  };

  const handleButtonClick = () => {
    navigate("/");
  };

  const mockData = question;
  // const [originalWords, setOriginalWords] = useState("");

  const originalWords = mockData.question;

  return (
    <div>
      <div className="relative top-10 bg-gray-100 max-w-full py-5 px-5 md:px-10 mx-4 rounded-sm border border-t-2">
        <div className="max-w-full bg-blue-500 h-3"></div>
        <h3 className="text-lg  pt-3 font-bold text-gray-900 sm:text-2xl ml-1 text-center md:text-start">
          Mock Test
        </h3>
        <h2 className=" absolute  text-1xl font-bold right-10 top-10">
          {" "}
        </h2>
        <h2 className=" absolute  text-sm font-semibold text-gray-700 right-10 top-13">
          {" "}
        Question {questionNumber} of 3
        </h2>
        <p className="p-2 py-6">
        You will have 20 minutes to plan, write and revise an essay about the topic below. your response will be judged on how well you develop a position, oraganize your ideas, present supporting details, and control the elements of standard written English. You should write 200-300 words.

</p>

        <QuestionBox question={originalWords}/>
        <div className="font-bold p-2 pt-4 ml-[1250px] ">Time left:<Timer initialMinutes={20} initialSeconds={0} /> </div>
        <WriteBox onTextChange={handleTextChange} />


      </div>
    </div>
  );
}
